import {ModalWrapper, Reoverlay} from "reoverlay";
import 'reoverlay/lib/ModalWrapper.css';
import {MdClose} from "react-icons/md";
const CharactersModal=({onSelect})=>{
    const plaqueLetters = [
         'ب',
         'ت',
         'ج',
         'د',
         'س',
         'ص',
         'ط',
         'ع',
         'ق',
         'ل',
         'م',
         'ن',
         'و',
         'ه',
         'ی',
         'ژ',
];
    const handleClose=()=>{
            Reoverlay.hideModal();
    }
    const handleClick=(char)=>{
        onSelect(char);
        Reoverlay.hideModal();
    }
    return <ModalWrapper  onClose={handleClose}  animation="zoom" contentContainerClassName="w-11/12 md:w-5/12  bg-gray-50 lg:w-4/12 p-5 rounded-xl">
                        <div className="flex justify-between mb-8 items-center">
                            <span>حرف پلاک خودرو را وارد کنید</span>
                            <MdClose onClick={handleClose} className="text-lg"/>
                        </div>
                        <div className="flex justify-center flex-wrap">
                            {plaqueLetters.map((char,index)=>{
                                return <div key={index} onClick={()=>handleClick(char)} className="flex p-5 m-1 justify-center items-center bg-gray-100 rounded-lg ">{char}</div>
                            })}
                        </div>

            </ModalWrapper>
}
export default CharactersModal;